// extracted by mini-css-extract-plugin
export default {"radioLabel":"LifeCycleStages_radioLabel__hmcH0","chip":"LifeCycleStages_chip__ZM4Sf"};